import gql from 'graphql-tag';
import { attendanceTeamFragment } from './fragments';

export const attendanceTeams = gql`
  query attendanceTeams($partnerPersonContextId: Int!) {
    attendanceTeams(partnerPersonContextId: $partnerPersonContextId) {
      ...attendanceTeamParts
    }
  }
  ${attendanceTeamFragment}
`;
